import DocumentRepository from "../Repository/DocumentRepository";
import Document from "../Entity/Document";

export default class ChangeDocumentDescription {
    public constructor(
        private readonly documentRepository: DocumentRepository
    ) {
    }

    public change(id: string, description: string): void {
        const document: Document | null = this.documentRepository.getById(id);
        if (null === document) {
            return;
        }

        document.setDescription(description);
        this.documentRepository.save(document);
    }
}